export default __webpack_public_path__ + "static/media/cyclejs.4cd94330.svg";